import React from 'react'
import styled, { keyframes } from 'styled-components'

import { Box, Column, Row, Text } from './styled'

const titles = [
  'GraphQL Backends',
  'Product Strategy',
  'Static Sites',
  'UI / UX',
  'Design Systems',
  'APIs',
  'Mobile / Desktop Apps'
]

const START_DELAY = 2 // seconds
const SPEED = 12 // lower means faster
const DELAY = 5 // % of total animation

const SIZE = titles.length

const Y = 100 / SIZE
const N = Number(((100 - DELAY) / SIZE).toFixed(4))

const sliderFrames = []

for (let i = 0; i <= SIZE; i++) {
  sliderFrames.push(
    `${N * i}%, ${N * i + DELAY}% { transform: translate3d(0, -${Y * i}%, 0); }`
  )
}

const vSlide = keyframes`${sliderFrames.join('\n')}`

const VSlider = styled(Column)`
  animation: ${vSlide} ${SPEED}s ease-in infinite ${START_DELAY}s;
  flex-shrink: 0;
  align-items: center;
`

function calculateFrame(i, frameNumber) {
  let scale = 0
  let opacity = 0
  let padding = 0.75
  let visibility = 'visible'
  if (i === frameNumber || i - SIZE === frameNumber) {
    scale = 1
    opacity = 1
    visibility = 'hidden'
  } else if (i === frameNumber - 1 || i - (SIZE - 1) === frameNumber) {
    scale = 0.72
    opacity = 0.5
    padding = 0.25
  } else if (i === frameNumber - 2 || i - (SIZE - 2) === frameNumber) {
    scale = 0.54
    opacity = 0.15
    padding = 0.1
  } else {
    visibility = 'hidden'
  }

  return {
    scale,
    opacity,
    padding,
    visibility
  }
}

const slideFrames = ({ i: index }) => {
  const frames = []
  for (let i = 0; i <= SIZE; i++) {
    const {
      scale,
      opacity,
      padding,
      visibility: nextVisibility
    } = calculateFrame(i, index)

    frames.push(
      `${N * i}%, ${N * i + DELAY}% {
        transform: scale3d(${scale}, ${scale}, 1);
        opacity: ${opacity};
        padding-bottom: ${padding}rem;
      }
      ${N * i + DELAY + 0.00001}% {
        visibility: ${nextVisibility};
      }
      `
    )
  }

  return keyframes`${frames.join('\n')}`
}

const VSlide = styled(Text)`
  flex-shrink: 0;
  font-size: 2.25rem;
  font-weight: 500;
  ${({ i }) => {
    const { scale, opacity, padding } = calculateFrame(0, i)
    return `
      opacity: ${opacity};
      transform: scale3d(${scale}, ${scale}, 1);
      padding-bottom: ${padding}rem;
    `
  }}
  animation: ${slideFrames} ${SPEED}s linear infinite ${START_DELAY}s;
`

const VerticalMarquee = () => (
  <Column
    width="36rem"
    height="16.5rem"
    css={{ overflowY: 'hidden' }}
    position="relative"
    pt="24px"
    display={['none', 'none', 'block']}
    alignItems="center"
  >
    <VSlider>
      {titles.map((t, i) => (
        <VSlide key={t} i={i}>
          {t}
        </VSlide>
      ))}
    </VSlider>
    <VSlider>
      {titles.map((t, i) => (
        <VSlide key={t} i={i}>
          {t}
        </VSlide>
      ))}
    </VSlider>
  </Column>
)

const slide = keyframes`
{
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(-100%, 0);
  }
}
`

const Slider = styled(Row)`
  animation: ${slide} 25s linear infinite;
  flex-shrink: 0;
`

const Slide = styled(Text)`
  padding-left: 4rem;
  flex-shrink: 0;
  font-size: 2.5rem;
  font-weight: 500;
`

const slider = (
  <Slider>
    {titles.map(t => (
      <Slide key={t}>{t}</Slide>
    ))}
  </Slider>
)

const HorizontalMarquee = () => (
  <Box
    my={6}
    position="relative"
    width="100%"
    display={['flex', 'flex', 'none']}
    height="3rem"
    css={{ overflowX: 'hidden' }}
  >
    <Row
      width="100%"
      css={{ whiteSpace: 'nowrap' }}
      position="absolute"
      top={0}
      left={0}
    >
      {slider}
      {slider}
    </Row>
  </Box>
)

const Marquee = () => (
  <>
    <VerticalMarquee />
    <HorizontalMarquee />
  </>
)

export default Marquee
